<template>
  <v-expansion-panel v-model="panel" expand popout style="margin: 0px!important;">
    <v-expansion-panel-content style="margin: 0px!important;">
      <div slot="header">
        <v-icon class="mr-1" color="grey" size="20">far fa-comment</v-icon>
        <span class="body-1 font-weight-regular mr-2"> {{ topic.commentNum }} comments</span>
      </div>
      <v-card>
        <div class="au-chat__content" ref="scrollList">
          <div class="mess-wrap recei-mess-wrap"
               v-for="(message, index) in messages" :key="'mess-' + index">
              <span class="mess-time">
                <span class="caption teal--text text--lighten-3">{{ message.user.name }}</span>
                <span v-if="message.createdAt" class="caption">
                  sent at February 16th 2019, 18:57</span>
              </span>
            <div class="recei-mess__inner">
              <v-avatar size="40">
                <img :src="message.user.avatar" :alt="message.user.name">
              </v-avatar>
              <div class="recei-mess-list">
                <div class="recei-mess grey lighten-3"
                     v-if="message.type === 'text'" v-html="message.data">
                </div>
                <div v-if="message.type === 'emoji'">
                  <emoji :emoji="message.data" :size="36" set="google"/>
                </div>
              </div>
            </div>
          </div>
          <v-textarea box class="mt-3" color="teal" rows="1" name="reply" placeholder="Write a reply"
                      value="" single-line height="12"
                      prepend-icon="far fa-smile" @click:prepend="picker = true"
                      append-outer-icon="send"></v-textarea>
        </div>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import firebase from 'firebase';
import { Emoji, Picker } from 'emoji-mart-vue';

export default {
  name: 'TopicCommentPanel',
  components: {
    Emoji,
    Picker,
  },
  props: {
    topic: Object,
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      panel: [
        this.isOpen,
      ],
      messages: [
        {
          user: { id: 'RpeicnqR1RcVB0llsyqb4uOGs2g1', name: 'Niishi Kubo', avatar: 'https://graph.facebook.com/1978173195612410/picture' },
          type: 'text',
          data: 'トピックへのコメント機能は絶賛もりもり開発中です！',
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          reactions: [
            { emoji: ':+1:', users: ['RpeicnqR1RcVB0llsyqb4uOGs2g1'] },
          ],
        },
        {
          user: { id: 'RpeicnqR1RcVB0llsyqb4uOGs2g1', name: 'Niishi Kubo', avatar: 'https://graph.facebook.com/1978173195612410/picture' },
          type: 'text',
          data: '今しばらくお待ち下さい。。。',
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        },
        {
          user: { id: 'RpeicnqR1RcVB0llsyqb4uOGs2g1', name: 'Niishi Kubo', avatar: 'https://graph.facebook.com/1978173195612410/picture' },
          type: 'emoji',
          data: ':muscle:',
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        },
      ],
      picker: false,
    };
  },
};
</script>

<style scoped>
  /*comments*/
  .au-chat__content {
    padding: 0 10px;
    overflow-y: auto;
    position: relative;
    font-size: 12px;
  }
  .mess-wrap {
    padding-bottom: 12px;
  }
  .recei-mess-wrap {
    text-align: center;
  }
  .mess-time {
    font-size: 14px;
    color: #999;
  }
  .recei-mess__inner {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 6px;
  }
  .recei-mess__inner {
    -webkit-align-self: flex-end;
    -ms-flex-item-align: end;
    align-self: flex-end;
    justify-self: flex-start;
    margin-right: 10px;
  }
  .recei-mess-list {
    margin-left: 12px;
  }
  .recei-mess {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    padding: 8px 16px;
    max-width: 100%;
    margin-bottom: 2px;
    text-align: left;
    white-space:pre-wrap;
    white-space: -moz-pre-wrap;
    word-wrap:break-word;
    overflow-wrap: break-word;
  }
</style>
